import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ManyEntity } from '@wilson/base';
import { ConfigOptions, ConfigService } from '@wilson/config';
import { ShiftState, ShiftWithAzmAttributes } from '@wilson/interfaces';
import { stringify } from 'qs';
import { Observable } from 'rxjs';

export interface NumberRangeDto {
  min: number;
  max: number;
}
export interface GetShiftWorkTimesSearchDto {
  from: string;
  to: string;
  userIds?: string[];
  organizationalUnitIds?: string[];
  deviationRange?: NumberRangeDto;
  hasShiftNote?: boolean;
  hasReportComments?: boolean;
  agreementIds?: string[];
  allActivitiesHaveAgreement?: boolean;
  projectIds?: string[];
  labelIds?: string[];
  shiftState?: ShiftState[];
  hasReportAttachment?: boolean;
  shiftCategoryIds?: string[];
}

export enum SortOrder {
  ASC = 'asc',
  DESC = 'desc',
}

export enum ShiftAttachmentsFilterEnum {
  WithoutReports = 'withoutReports',
  WithReports = 'withReports',
}

export enum ShiftDeviatonNoteFilterEnum {
  WithoutDeviationNote = 'withoutDeviationNote',
  WithDeviationNote = 'withDeviationNote',
}

export interface AzmSortColumns {
  name: SortOrder | undefined;
  startDate: SortOrder | undefined;
  projectId: SortOrder | undefined;
  labels: { _count: SortOrder } | undefined;
  createdFrom: SortOrder | undefined;
  plannedDuration: SortOrder | undefined;
  reportedDuration: SortOrder | undefined;
  startDateTime: SortOrder | undefined;
  endDateTime: SortOrder | undefined;
  startLocation: { locationCode: SortOrder } | undefined;
  endLocation: { locationCode: SortOrder } | undefined;
  user: { lastName: SortOrder } | undefined;
}

export interface PaginationOptions {
  pageNumber: number;
  pageSize: number;
  orderBy: AzmSortColumns;
}

@Injectable({
  providedIn: 'root',
})
export class ShiftWorkTimesGateway {
  protected readonly http = inject(HttpClient);
  protected readonly config = inject<ConfigOptions>(ConfigService);

  public getShifts(
    where: GetShiftWorkTimesSearchDto,
    paginationOptions: PaginationOptions,
  ): Observable<ManyEntity<ShiftWithAzmAttributes>> {
    const params = stringify({
      ...paginationOptions,
    });

    return this.http.post<ManyEntity<ShiftWithAzmAttributes>>(
      `${this.config.host}/v2/shift-work-times?${params}`,
      where,
    );
  }
}
